export enum CHIP_TYPES {
  SELECTABLE = 'selectable',
  DEFAULT = 'default'
}
